import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePassword, getWhatsappUrl } from '../../redux/actions/auth';
import { showToastNotif } from '../../redux/actions/notification';
import { Link } from 'react-router-dom';

import styles from './passwordModal.module.css';

const strongRegex = new RegExp(
  '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%&])(?=.{8,})'
);
const minLength = 8;
const PasswordModal = ({ open, onDismiss }) => {
  const [whatsappLink, setWhatsappLink] = useState(false);
  const auth = useSelector((state) => state.auth);
  const { account } = auth.user;
  const pass = useRef();
  const [error, setError] = useState(false);
  const confPass = useRef();
  const oldPass = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    const getWhatsapp = async () => {
      const { data } = await dispatch(getWhatsappUrl());
      setWhatsappLink(data?.value);
    };
    getWhatsapp();
  }, [dispatch]);

  const Dismiss = useCallback(() => {
    setError(false);
    onDismiss();
  }, [onDismiss]);

  const mapErrors = (err) => {
    switch (err.code) {
      case 'gfx4000003':
        setError('Old Password should NOT be shorter than 8 characters');
        break;
      case 'gfu4030207':
        setError('Your old password is incorrect');
        break;
      default:
        setError('Something went wrong, please try again later');
        break;
    }
  };

  const onSubmit = useCallback(async () => {
    if (pass.current.value !== confPass.current.value) {
      return setError('Your confirmation password is not matching');
    }
    if (!strongRegex.test(pass.current.value)) {
      return setError(
        'Your password must contain at least 8 characters with lowercase, uppercase, number and special character'
      );
    }
    const res = await dispatch(
      updatePassword(
        oldPass.current.value,
        pass.current.value,
        confPass.current.value
      )
    );
    if (!res.error) {
      dispatch(showToastNotif('success', 'Your password has been updated'));
      Dismiss();
    }
    res.error && mapErrors(res.error);
  }, [pass, confPass, dispatch, Dismiss]);

  return (
    <>
      <div className={`${styles.passModal} ${open ? styles.show : ''}`}>
        <div className={styles.passWrapper}>
          <div className={styles.passContent}>
            <span className={styles.passClose} onClick={Dismiss}>
              X
            </span>
            <h3>Change Password</h3>
            <hr />
            <span className={styles.passHelper}>
              For security, please enter your old password.
            </span>
            <span className={styles.passWarning}>{error}</span>
            <section>
              <span>Old Password</span>
              <input ref={oldPass} type='password' className={styles.pwd} />
              {account.email && (
                <Link
                  to={`/forgot-password?email=${encodeURIComponent(
                    account.email
                  )}`}
                  className={styles.forgot}
                >
                  <span>Forgot password?</span>
                </Link>
              )}
              {!account.email && whatsappLink && (
                <a
                  className={styles.forgot}
                  href={whatsappLink}
                  target='__blank'
                >
                  <span>Forgot password? Contact our support.</span>
                </a>
              )}
            </section>
            <section>
              <span>New Password</span>
              <input
                ref={pass}
                type='password'
                minLength={minLength}
                className={styles.pwd}
              />
            </section>
            <section>
              <span>Reenter New Password</span>
              <input
                ref={confPass}
                type='password'
                minLength={minLength}
                className={styles.pwd}
              />
            </section>
            <section>
              <button onClick={onSubmit}>Change Password</button>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default PasswordModal;
